<template>
  <el-dialog title="Dados da Integração" center :visible.sync="dialog" :before-close="close"
    :close-on-click-modal="false">
    <el-alert :description="error" type="error" :closable="false">
    </el-alert>
    <el-form size="mini">
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item prop="register">
            <br />
            <el-checkbox v-model="record.object.ar">A.R.</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item prop="length">
            <br />
            <el-checkbox v-model="record.object.ownhand">M.P.</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item label="CEP Origem" prop="sourcezipcode">
            <el-input maxlength="9" v-model="record.sender.cep" v-mask="'#####-###'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="12" :xl="12">
          <el-form-item :label="$t('endereco')" prop="sourceaddress">
            <el-input v-model="record.sender.address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('numero')" prop="sourcenumber">
            <el-input type="number" maxlength="6" v-model="record.sender.number" v-mask="'######'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('bairro')" prop="neighborhood">
            <el-input v-model="record.sender.neighborhood" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('cidade')" prop="neighborhood">
            <el-input v-model="record.sender.city"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('estado')" prop="neighborhood">
            <el-input v-model="record.sender.state"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('contato')" prop="extent">
            <el-input v-model="record.delivery.contact" maxlength="60"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('complemento')" prop="extent">
            <el-input v-model="record.sender.complement" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('nome')" prop="extent">
            <el-input v-model="record.delivery.name" maxlength="60"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('aos-cuidados')" prop="care">
            <el-input v-model="record.contact.care" maxlength="255"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item label="CEP Destino" prop="destinyzipcode">
            <el-input maxlength="9" v-model="record.delivery.cep" v-mask="'#####-###'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="12" :xl="12">
          <el-form-item :label="$t('endereco')" prop="sourceaddress">
            <el-input v-model="record.delivery.address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('numero')" prop="destinynumber">
            <el-input type="number" maxlength="6" v-model="record.delivery.number" v-mask="'######'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('bairro')" prop="neighborhood">
            <el-input v-model="record.delivery.neighborhood" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('cidade')" prop="neighborhood">
            <el-input v-model="record.delivery.city" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('estado')" prop="neighborhood">
            <el-input v-model="record.delivery.state" maxlength="2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('complemento')" prop="extent">
            <el-input v-model="record.delivery.extent" maxlength="26"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="12" :sm="10" :md="8" :lg="8" :xl="8">
          <el-form-item :label="$t('servico')" prop="service">
            <el-input v-model="record.service" maxlength="8"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('altura')" prop="height">
            <el-input v-model="record.complement.height"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('comprimento')" prop="width">
            <el-input v-model="record.complement.width"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('largura')" prop="length">
            <el-input v-model="record.complement.length"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('peso')" prop="weight">
            <el-input v-model="record.object.weight"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('valor-declarado')" prop="declaredValue">
            <el-input type="number" v-model="record.complement.value"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="10" :xl="10">
          <el-form-item class="no-margin-bottom" :label="$t('tipo')" prop="type">
            <el-select v-model="record.complement.type">
              <el-option key="003" label="Envelope" value="003"></el-option>
              <el-option key="001" label="Pacote / Caixa" value="001"></el-option>
              <el-option key="002" label="Rolo / Cilindro / Esférico" value="002"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item label="Nota" prop="invoice">
            <el-input v-model="record.contact.invoice"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
          <el-form-item class="no-margin-bottom" :label="$t('pedido')">
            <el-input v-model="record.contact.request"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="E-mail" prop="mail">
            <el-input v-model="record.contact.mail"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="Telefone" prop="phone">
            <el-input v-model="record.contact.phone" maxlength="20"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="24" :xl="24">
          <el-form-item :label="$t('observacao')" prop="observation">
            <el-input type="textarea" v-model="record.contact.observation"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="20">
          <el-form-item prop="typeContent">
            <el-radio v-model="record.complement.typeContent" label="1" value="1">Com nota fiscal</el-radio
            >
            <el-radio v-model="record.complement.typeContent" label="3"  value="3"
              >Emitir DC-E</el-radio
            >
            <el-radio v-model="record.complement.typeContent" label="4"  value="4"
              >Enviar NF-E posteriormente</el-radio
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="24" :xl="24">
          <el-form-item label="Chave NFE/DC Id" prop="nfeKey">
            <el-input type="text" v-model="record.nf.nfeKey"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="Conteudo" prop="content">
            <el-input type="text" v-model="record.dc[0].content"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <el-form-item label="Qtde" prop="quantity">
            <el-input type="text" v-model="record.dc[0].quantity"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <el-form-item label="Valor" prop="value">
            <el-input type="text" v-model="record.dc[0].value"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="save()">Re-enviar</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { PrepostService } from "@/services/customers/prepost.services";
import { UserService } from "@/services/users/user.services";

export default {
  name: "prepost",
  data() {
    return {
      dialog: false,
      error: "",
      record: {
        sender: {
          contact: "",
          cep: "",
          address: "",
          neighborhood: "",
          city: "",
          state: "",
          number: "",
          extent: ""
        },
        delivery: {
          delivery: null,
          contact: "",
          department: null,
          name: "",
          branch: null,
          cep: "",
          address: "",
          neighborhood: "",
          city: "",
          state: "",
          number: "",
          extent: ""
        },
        contact: {
          phone: "",
          mail: "",
          federalid: "",
          invoice: "",
          care: "",
          request: "",
          note: "",
          save: true,
          observation: ""
        },
        object: {
          object: null,
          package: null,
          mdp: "",
          ar: false,
          ownhand: false,
          weight: 0,
          quantity: 1,
          type: null
        },
        complement: {
          height: 6,
          width: 18,
          length: 15,
          value: 0,
          total: 0,
          diameter: 0,
          type: "001",
          typeContent: "1"
        },
        nf: {
          nfeKey: '',
        },
        service: "03220",
        customer: null,
        cardpost: null,
        dc: [{
          content: '',
          quantity: 1,
          value: 1,
        }],
      },
      id: '',
      user: {
        type: "2",
        name: "",
      },
    };
  },
  methods: {
    open(data, error, id) {
      const vm = this;
      try {
        const prepost = JSON.parse(data)
        if (prepost && !prepost.object) {
          throw new Error('json invalid')
        }
        if (!prepost.dc || prepost.dc.length == 0) {
          prepost.dc = [{
            content: '',
            quantity: 1,
            value: 1,
          }]
        }
        if (!prepost.complement.typeContent) {
          prepost.complement.typeContent = '3'
        }
        if (!prepost.nf) {
          prepost.nf = {
            nfeKey: '',
          }
        }
        vm.record = prepost;
        vm.error = error;
        vm.id = id;
        vm.dialog = true;
      } catch (e) {
        this.$message({
          type: "error",
          duration: 5000,
          message: "Dados de origem inválidos não é possivel corrigir!",
        });
      }
    },
    close() {
      this.dialog = false;
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      PrepostService.add(
        vm.record.customer,
        vm.record.sender,
        vm.record.delivery,
        vm.record.contact,
        vm.record.object,
        vm.record.complement,
        vm.record.service,
        "",
        vm.record.dc,
        vm.record.nf,
      )
        .then((response) => {
          this.$message({
            type: "success",
            message: `Integração realizada com sucesso!`,
          });
          vm.$emit('update', vm.id)
          vm.dialog = false;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.user.name = response.name;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
